import type { FC, PropsWithChildren } from 'react';
import { cx } from '../../utils/cx';
import styles from './Prose.module.css';

export interface ProseProps {
  className?: string;
  centered?: boolean;
}

export const Prose: FC<PropsWithChildren<ProseProps>> = ({
  className,
  centered = true,
  children,
}) => (
  <div className={cx(styles.prose, centered && styles.centered, className)}>
    {children}
  </div>
);

export const prose = {
  eyebrow: styles.eyebrow,
  deck: styles.deck,
  lead: styles.lead,
  caption: styles.caption,
  technical: styles.technical,
  small: styles.small,
  dropcap: styles.dropcap,
  pullquote: styles.pullquote,
  footnotes: styles.footnotes,
};
